import {
  ICliente,
  IClientexdel,
  IDivisa,
  IPais,
  IUsuarioCrear,
  IUsuarioModif,
  Pais,
} from "@/entities";

export class Cliente implements ICliente {
  active: boolean;
  clientexdels: IClientexdel[];
  codCliente: string;
  desCliente: string;
  codDesCliente: string;
  divisas: IDivisa[];
  fecBaja: string;
  fecCrear: string;
  fecModif: string;
  id?: number | null;
  pais: IPais;
  usuarioCrear?: IUsuarioCrear;
  usuarioModificar?: IUsuarioModif;
  fakeCerts: boolean;
  expirationTime: string;
  intraDay: boolean;

  constructor() {
    this.active = false;
    this.clientexdels = [];
    this.codCliente = "";
    this.desCliente = "";
    this.codDesCliente = "";
    this.divisas = [];
    this.fecBaja = "";
    this.fecCrear = "";
    this.fecModif = "";
    this.id = null;
    this.pais = new Pais();
    this.fakeCerts = false;
    this.expirationTime = "";
    this.intraDay = false;
  }
}
